export default "__VITE_ASSET__D2XEVXr3__"